import React, { Component } from 'react'
import { Col, Label, Row } from 'reactstrap'
import { formatNullableValue } from '../../../utils/formatar';

export default class BloqueioBlCard extends Component {

    constructor(props){
        super(props)

        this.controller = this.props.controller

    }


    render() {
        return (
            <Col  xs={12} md={6} lg={4}>
                <div className="card-navio">
                    <Row>
                        <Col xs={12} className="px-0">
                            <div className="titulo">
                                <Label className="titulo-principal">{ this.props.data[this.props.titulo] }</Label>
                                <Label className="subtitulo">{ this.props.data[this.props.subtitulo] }</Label>
                            </div>
                        </Col>

                        {this.props.colunas.map((col, x) =>
                            (col.dataField !== this.props.titulo) &&
                            (col.dataField !== this.props.subtitulo) &&
                            (col.dataField !== "acoes") &&
                            (col.dataField !== "excluir") &&
                            <Col xs={6} className="px-0" key={x}>
                                <div className="info bg-cinza">
                                    <div className="titulo">{col.text}</div>
                                    <div className="valor">{col.formatter ?
                                        (
                                            col.formatExtraData ?
                                                formatNullableValue(col.formatter(col.dataField.split('.').reduce((o, i) => o[i], this.props.data), col, null, col.formatExtraData))
                                                :
                                                formatNullableValue(col.formatter(col.dataField.split('.').reduce((o, i) => o[i], this.props.data)))
                                        )
                                        :
                                        formatNullableValue(col.dataField.split('.').reduce((o, i) => o[i], this.props.data))
                                    }</div>
                                </div>
                            </Col>
                        )}

                    </Row>
                    <Row className="align-items-center">
                    {this.props.colunas.map((col, x) =>
                        (col.dataField === "acoes" || col.dataField === "excluir") &&
                        <Col xs={6} className="px-0" key={x}>
                            <div className="info">
                                <div className="valor">{col.formatter ?
                                    (
                                        col.formatExtraData ?
                                            formatNullableValue(col.formatter(col.dataField.split('.').reduce((o, i) => o[i], this.props.data), col, null, col.formatExtraData))
                                            :
                                            formatNullableValue(col.formatter(col.dataField.split('.').reduce((o, i) => o[i], this.props.data)))
                                    )
                                    :
                                    formatNullableValue(col.dataField.split('.').reduce((o, i) => o[i], this.props.data))
                                }</div>
                            </div>
                        </Col>
                    )}
                    </Row>
                </div>
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/bloqueiobl/components/BloqueioBlCard.js